import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191'),
	() => import('./nodes/192'),
	() => import('./nodes/193'),
	() => import('./nodes/194'),
	() => import('./nodes/195'),
	() => import('./nodes/196'),
	() => import('./nodes/197'),
	() => import('./nodes/198'),
	() => import('./nodes/199'),
	() => import('./nodes/200'),
	() => import('./nodes/201'),
	() => import('./nodes/202'),
	() => import('./nodes/203'),
	() => import('./nodes/204'),
	() => import('./nodes/205'),
	() => import('./nodes/206'),
	() => import('./nodes/207'),
	() => import('./nodes/208'),
	() => import('./nodes/209'),
	() => import('./nodes/210'),
	() => import('./nodes/211'),
	() => import('./nodes/212'),
	() => import('./nodes/213'),
	() => import('./nodes/214'),
	() => import('./nodes/215'),
	() => import('./nodes/216'),
	() => import('./nodes/217'),
	() => import('./nodes/218'),
	() => import('./nodes/219'),
	() => import('./nodes/220'),
	() => import('./nodes/221'),
	() => import('./nodes/222'),
	() => import('./nodes/223'),
	() => import('./nodes/224'),
	() => import('./nodes/225'),
	() => import('./nodes/226'),
	() => import('./nodes/227'),
	() => import('./nodes/228'),
	() => import('./nodes/229'),
	() => import('./nodes/230'),
	() => import('./nodes/231'),
	() => import('./nodes/232'),
	() => import('./nodes/233'),
	() => import('./nodes/234'),
	() => import('./nodes/235'),
	() => import('./nodes/236'),
	() => import('./nodes/237'),
	() => import('./nodes/238'),
	() => import('./nodes/239'),
	() => import('./nodes/240'),
	() => import('./nodes/241'),
	() => import('./nodes/242'),
	() => import('./nodes/243'),
	() => import('./nodes/244'),
	() => import('./nodes/245'),
	() => import('./nodes/246'),
	() => import('./nodes/247'),
	() => import('./nodes/248'),
	() => import('./nodes/249'),
	() => import('./nodes/250'),
	() => import('./nodes/251'),
	() => import('./nodes/252'),
	() => import('./nodes/253'),
	() => import('./nodes/254'),
	() => import('./nodes/255'),
	() => import('./nodes/256'),
	() => import('./nodes/257'),
	() => import('./nodes/258'),
	() => import('./nodes/259'),
	() => import('./nodes/260'),
	() => import('./nodes/261'),
	() => import('./nodes/262'),
	() => import('./nodes/263'),
	() => import('./nodes/264'),
	() => import('./nodes/265'),
	() => import('./nodes/266'),
	() => import('./nodes/267'),
	() => import('./nodes/268'),
	() => import('./nodes/269'),
	() => import('./nodes/270'),
	() => import('./nodes/271'),
	() => import('./nodes/272'),
	() => import('./nodes/273'),
	() => import('./nodes/274'),
	() => import('./nodes/275'),
	() => import('./nodes/276'),
	() => import('./nodes/277'),
	() => import('./nodes/278'),
	() => import('./nodes/279'),
	() => import('./nodes/280'),
	() => import('./nodes/281'),
	() => import('./nodes/282'),
	() => import('./nodes/283'),
	() => import('./nodes/284'),
	() => import('./nodes/285'),
	() => import('./nodes/286'),
	() => import('./nodes/287'),
	() => import('./nodes/288'),
	() => import('./nodes/289'),
	() => import('./nodes/290'),
	() => import('./nodes/291'),
	() => import('./nodes/292'),
	() => import('./nodes/293'),
	() => import('./nodes/294'),
	() => import('./nodes/295'),
	() => import('./nodes/296'),
	() => import('./nodes/297')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/404": [4],
		"/bag": [5],
		"/blog": [6],
		"/contact": [7],
		"/index.html": [8],
		"/mission": [9],
		"/posts/abort-controller": [10,[2]],
		"/posts/abortcontroller": [11,[2]],
		"/posts/accessibility-tree": [12,[2]],
		"/posts/acid": [13,[2]],
		"/posts/api-gateway": [14,[2]],
		"/posts/aria-live-regions-internals": [15,[2]],
		"/posts/aria-notify": [16,[2]],
		"/posts/automatic-batching-react-18": [17,[2]],
		"/posts/avif-image-format-guide": [18,[2]],
		"/posts/b-tree": [19,[2]],
		"/posts/backpressure-in-streams-api": [21,[2]],
		"/posts/backpressure": [20,[2]],
		"/posts/base": [22,[2]],
		"/posts/bloom-filter": [23,[2]],
		"/posts/broadcast-channel-api": [24,[2]],
		"/posts/browser-compositing-layers": [25,[2]],
		"/posts/browser-memory-leak-detection": [26,[2]],
		"/posts/cache-invalidation-strategies": [28,[2]],
		"/posts/cache-invalidation": [27,[2]],
		"/posts/cache-stampede": [29,[2]],
		"/posts/caching": [30,[2]],
		"/posts/cap-theorem": [31,[2]],
		"/posts/cdc-change-data-capture": [32,[2]],
		"/posts/checkpointing": [33,[2]],
		"/posts/circuit-breaker": [34,[2]],
		"/posts/clustering": [35,[2]],
		"/posts/code-splitting-react-lazy": [36,[2]],
		"/posts/code-splitting-strategies": [37,[2]],
		"/posts/columnar-storage": [38,[2]],
		"/posts/compaction": [39,[2]],
		"/posts/composite-index": [40,[2]],
		"/posts/concurrent-rendering": [41,[2]],
		"/posts/connection-pooling": [42,[2]],
		"/posts/consensus": [43,[2]],
		"/posts/consistent-hashing": [44,[2]],
		"/posts/container-queries-scoped-css": [45,[2]],
		"/posts/content-security-policy-csp": [46,[2]],
		"/posts/context-api-rerender-optimization": [47,[2]],
		"/posts/cors-preflight": [48,[2]],
		"/posts/cost-based-optimizer": [49,[2]],
		"/posts/covering-index": [50,[2]],
		"/posts/crdt-basics-for-collaboration": [51,[2]],
		"/posts/critical-rendering-path": [52,[2]],
		"/posts/csr-vs-ssr-vs-ssg": [53,[2]],
		"/posts/csrf-vs-xss-mitigation": [55,[2]],
		"/posts/csrf": [54,[2]],
		"/posts/css-anchor-positioning": [56,[2]],
		"/posts/css-anchor-scope": [57,[2]],
		"/posts/css-at-property": [58,[2]],
		"/posts/css-attr-function": [59,[2]],
		"/posts/css-border-image": [60,[2]],
		"/posts/css-border-shape": [61,[2]],
		"/posts/css-color-contrast": [62,[2]],
		"/posts/css-container-queries": [63,[2]],
		"/posts/css-containment": [64,[2]],
		"/posts/css-custom-highlight-api": [65,[2]],
		"/posts/css-focus-visible": [66,[2]],
		"/posts/css-focus-within": [67,[2]],
		"/posts/css-functions": [68,[2]],
		"/posts/css-grid-lanes": [69,[2]],
		"/posts/css-has-selector": [70,[2]],
		"/posts/css-masonry-grid-lanes": [71,[2]],
		"/posts/css-multicolumn-wrap": [72,[2]],
		"/posts/css-nth-child-of": [73,[2]],
		"/posts/css-popover-api": [74,[2]],
		"/posts/css-random": [75,[2]],
		"/posts/css-relative-colors": [76,[2]],
		"/posts/css-revert-rule": [77,[2]],
		"/posts/css-scope": [78,[2]],
		"/posts/css-scroll-snapping": [79,[2]],
		"/posts/css-scroll-state-queries": [80,[2]],
		"/posts/css-scroll-timeline-animations": [81,[2]],
		"/posts/css-shape": [82,[2]],
		"/posts/css-starting-style": [83,[2]],
		"/posts/css-sticky-x-and-y": [84,[2]],
		"/posts/css-style-queries": [85,[2]],
		"/posts/css-subgrid": [86,[2]],
		"/posts/css-user-valid-invalid": [87,[2]],
		"/posts/css-zoom": [88,[2]],
		"/posts/cumulative-layout-shift-cls": [89,[2]],
		"/posts/custom-elements-lifecycle": [90,[2]],
		"/posts/custom-hooks-design-patterns": [91,[2]],
		"/posts/customizable-select": [92,[2]],
		"/posts/data-lake": [93,[2]],
		"/posts/data-locality": [94,[2]],
		"/posts/data-migration": [95,[2]],
		"/posts/data-skew": [96,[2]],
		"/posts/data-warehouse": [97,[2]],
		"/posts/deadlock": [98,[2]],
		"/posts/denormalization": [99,[2]],
		"/posts/dependency-array-pitfalls": [100,[2]],
		"/posts/design-systems-at-scale": [101,[2]],
		"/posts/detached-dom-nodes": [102,[2]],
		"/posts/deterministic-rendering": [103,[2]],
		"/posts/dirty-read": [104,[2]],
		"/posts/dom-clobbering": [105,[2]],
		"/posts/dynamic-import-chunking": [106,[2]],
		"/posts/edge-rendering": [107,[2]],
		"/posts/element-scoped-view-transitions": [108,[2]],
		"/posts/error-boundaries": [109,[2]],
		"/posts/etag-vs-cache-control": [110,[2]],
		"/posts/event-loop-macro-vs-microtasks": [111,[2]],
		"/posts/event-sourcing-in-frontend": [112,[2]],
		"/posts/eventual-consistency": [113,[2]],
		"/posts/exactly-once-semantics": [114,[2]],
		"/posts/failover": [115,[2]],
		"/posts/false-sharing": [116,[2]],
		"/posts/federation": [117,[2]],
		"/posts/fiber-architecture": [118,[2]],
		"/posts/finite-state-modeling": [119,[2]],
		"/posts/first-input-delay-fid": [120,[2]],
		"/posts/fit-text": [121,[2]],
		"/posts/forward-refs": [122,[2]],
		"/posts/garbage-collection-timing": [123,[2]],
		"/posts/geo-replication": [124,[2]],
		"/posts/glm5-zed-agentic-setup": [125,[2]],
		"/posts/gpu-acceleration-in-css": [126,[2]],
		"/posts/graphql": [127,[2]],
		"/posts/grpc": [128,[2]],
		"/posts/haptic-feedback-vibration-api": [129,[2]],
		"/posts/hash-partitioning": [130,[2]],
		"/posts/high-availability-ha": [131,[2]],
		"/posts/higher-order-components": [132,[2]],
		"/posts/horizontal-scaling": [133,[2]],
		"/posts/hot-partition": [134,[2]],
		"/posts/html-in-canvas": [135,[2]],
		"/posts/http-3-and-quic": [136,[2]],
		"/posts/hydration-ssr": [138,[2]],
		"/posts/hydration": [137,[2]],
		"/posts/idempotency": [139,[2]],
		"/posts/idempotent-ui-actions": [140,[2]],
		"/posts/img-sizes-auto": [141,[2]],
		"/posts/immutability-structural-sharing": [142,[2]],
		"/posts/immutable-data-patterns": [143,[2]],
		"/posts/indexeddb": [144,[2]],
		"/posts/indexing": [145,[2]],
		"/posts/interaction-to-next-paint-inp": [146,[2]],
		"/posts/intersectionobserver-internals": [147,[2]],
		"/posts/invokers-api": [148,[2]],
		"/posts/islands-architecture": [149,[2]],
		"/posts/jpeg-xl": [150,[2]],
		"/posts/jwt": [151,[2]],
		"/posts/keys-and-list-rerender": [152,[2]],
		"/posts/largest-contentful-paint-lcp": [153,[2]],
		"/posts/layout-thrashing": [154,[2]],
		"/posts/leader-follower-replication": [155,[2]],
		"/posts/lifting-state-up": [156,[2]],
		"/posts/light-dark-image-support": [157,[2]],
		"/posts/light-dark-mode-made-simple": [158,[2]],
		"/posts/livelock": [159,[2]],
		"/posts/load-balancer": [160,[2]],
		"/posts/load-balancing": [161,[2]],
		"/posts/lock-escalation": [162,[2]],
		"/posts/logical-replication": [163,[2]],
		"/posts/long-tasks-api": [164,[2]],
		"/posts/lsm-tree": [165,[2]],
		"/posts/materialized-views": [166,[2]],
		"/posts/media-pseudo-classes": [167,[2]],
		"/posts/media-state-pseudo-classes": [168,[2]],
		"/posts/memoization-pitfalls": [169,[2]],
		"/posts/memoization-react": [170,[2]],
		"/posts/micro-frontend-orchestration": [171,[2]],
		"/posts/microtask-vs-macrotask": [172,[2]],
		"/posts/modern-javascript-features": [173,[2]],
		"/posts/module-federation": [174,[2]],
		"/posts/mtls": [175,[2]],
		"/posts/multi-leader-replication": [176,[2]],
		"/posts/mutationobserver-cost": [177,[2]],
		"/posts/mvcc-multi-version-concurrency-control": [178,[2]],
		"/posts/navigation-api": [179,[2]],
		"/posts/normalization": [180,[2]],
		"/posts/oauth": [181,[2]],
		"/posts/offline-conflict-resolution": [182,[2]],
		"/posts/offscreencanvas": [183,[2]],
		"/posts/optimistic-locking": [184,[2]],
		"/posts/optimistic-ui-rollback-strategy": [185,[2]],
		"/posts/optimistic-ui-updates": [186,[2]],
		"/posts/p3-color-gamut": [187,[2]],
		"/posts/page-view-transitions": [188,[2]],
		"/posts/pagination": [189,[2]],
		"/posts/paint-vs-composite-vs-layout": [190,[2]],
		"/posts/partial-hydration": [191,[2]],
		"/posts/performanceobserver-api": [192,[2]],
		"/posts/pessimistic-locking": [193,[2]],
		"/posts/phantom-read": [194,[2]],
		"/posts/physical-replication": [195,[2]],
		"/posts/pointer-events": [196,[2]],
		"/posts/preload-vs-prefetch-vs-preconnect": [197,[2]],
		"/posts/pretext": [198,[2]],
		"/posts/priority-hints": [199,[2]],
		"/posts/priority-inversion-in-async-code": [200,[2]],
		"/posts/prop-drilling-vs-composition": [201,[2]],
		"/posts/prototype-pollution": [202,[2]],
		"/posts/query-optimization": [203,[2]],
		"/posts/query-planner": [204,[2]],
		"/posts/quorum": [205,[2]],
		"/posts/race-conditions-in-ui-state": [206,[2]],
		"/posts/range-partitioning": [207,[2]],
		"/posts/rate-limiting": [208,[2]],
		"/posts/react-devtools-profiler": [209,[2]],
		"/posts/react-fiber-architecture": [210,[2]],
		"/posts/react-reconciliation": [211,[2]],
		"/posts/read-replicas": [212,[2]],
		"/posts/read-skew": [213,[2]],
		"/posts/rebalancing": [214,[2]],
		"/posts/reconciliation-algorithm": [215,[2]],
		"/posts/referential-equality": [216,[2]],
		"/posts/render-bailout-conditions": [217,[2]],
		"/posts/render-blocking-resources": [218,[2]],
		"/posts/render-props-pattern": [219,[2]],
		"/posts/render-waterfalls": [220,[2]],
		"/posts/resharding": [221,[2]],
		"/posts/resizeobserver-loop-limits": [222,[2]],
		"/posts/responsive-design-patterns": [223,[2]],
		"/posts/reverse-proxy": [224,[2]],
		"/posts/row-based-storage": [225,[2]],
		"/posts/samesite-cookie-modes": [226,[2]],
		"/posts/scheduler-priorities": [227,[2]],
		"/posts/schema-evolution": [228,[2]],
		"/posts/schema-registry": [229,[2]],
		"/posts/scroll-animations": [230,[2]],
		"/posts/scroll-driven-variable-fonts": [231,[2]],
		"/posts/search-text-pseudo-class": [232,[2]],
		"/posts/secondary-indexes": [233,[2]],
		"/posts/selective-hydration": [234,[2]],
		"/posts/server-components": [235,[2]],
		"/posts/service-worker-lifecycle-traps": [236,[2]],
		"/posts/shadow-dom": [237,[2]],
		"/posts/sharding": [238,[2]],
		"/posts/sharedarraybuffer": [239,[2]],
		"/posts/snapshot-isolation": [240,[2]],
		"/posts/speculative-prerendering": [241,[2]],
		"/posts/split-brain": [242,[2]],
		"/posts/stale-closure-problem": [243,[2]],
		"/posts/stale-closures": [244,[2]],
		"/posts/stale-while-revalidate": [245,[2]],
		"/posts/start-transition": [246,[2]],
		"/posts/state-colocation": [247,[2]],
		"/posts/streaming-fetch-response-handling": [248,[2]],
		"/posts/streaming-ssr": [249,[2]],
		"/posts/strict-mode": [250,[2]],
		"/posts/strong-consistency": [251,[2]],
		"/posts/structural-sharing": [252,[2]],
		"/posts/subpixel-rendering": [253,[2]],
		"/posts/suspense-boundaries": [254,[2]],
		"/posts/sveltekit-best-practices": [255,[2]],
		"/posts/syntax-highlighting-font": [256,[2]],
		"/posts/synthetic-event-system": [257,[2]],
		"/posts/tanstack": [258,[2]],
		"/posts/task-starvation": [259,[2]],
		"/posts/tearing-in-concurrent-ui": [260,[2]],
		"/posts/three-phase-commit-3pc": [261,[2]],
		"/posts/throttling": [262,[2]],
		"/posts/time-series-partitioning": [263,[2]],
		"/posts/time-slicing": [264,[2]],
		"/posts/tldraw": [265,[2]],
		"/posts/transferable-objects": [266,[2]],
		"/posts/tree-shaking-internals": [268,[2]],
		"/posts/tree-shaking": [267,[2]],
		"/posts/trusted-types": [269,[2]],
		"/posts/two-phase-commit-2pc": [270,[2]],
		"/posts/understanding-css-animations": [271,[2]],
		"/posts/use-effect-cleanup-timing": [272,[2]],
		"/posts/use-imperative-handle": [273,[2]],
		"/posts/use-layout-effect": [274,[2]],
		"/posts/use-reducer-patterns": [275,[2]],
		"/posts/vertical-scaling": [276,[2]],
		"/posts/virtual-dom-diffing-complexity": [278,[2]],
		"/posts/virtual-dom-diffing": [277,[2]],
		"/posts/vite-plus-and-voidzero": [279,[2]],
		"/posts/warrior-of-the-gods-easter-egg": [280,[2]],
		"/posts/web-accessibility-guide": [281,[2]],
		"/posts/web-compat": [282,[2]],
		"/posts/web-components-interoperability": [283,[2]],
		"/posts/web-performance-optimization": [284,[2]],
		"/posts/web-workers-vs-service-workers": [285,[2]],
		"/posts/webassembly-integration": [286,[2]],
		"/posts/webhooks": [287,[2]],
		"/posts/webrtc": [288,[2]],
		"/posts/webtransport": [289,[2]],
		"/posts/webvtt": [290,[2]],
		"/posts/write-ahead-logging-wal": [291,[2]],
		"/posts/write-skew": [292,[2]],
		"/process": [293],
		"/services": [294],
		"/stats": [295],
		"/warrior-of-the-gods": [296],
		"/work": [297]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';